module.exports = __webpack_public_path__ + "assets/34.jpg?984d4973d8912038d8b4fb5e73d32f33";